// FAQ accordion — accessible, single-or-multi open
document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.faq-accordion .faq-item');
    if (!items.length) return;

    items.forEach((item) => {
        const btn = item.querySelector('.faq-q');
        const panel = item.querySelector('.faq-a');
        if (!btn || !panel) return;

        btn.addEventListener('click', () => {
            const isOpen = item.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            if (isOpen) {
                panel.removeAttribute('hidden');
            } else {
                // krótka pauza by domknąć animację przed hidden
                setTimeout(() => panel.setAttribute('hidden', ''), 280);
            }
        });
    });
});
